/*
'use strict'

{
  let log = (str = 'hello') => {
    console.log(str)
  }
  log('hello world!')
}
*/
"use strict";